import React from 'react';
import { titleCase } from '../../utils/titleCase';

interface StackedCellProps {
  /** A CHAR(10)-joined value: the first line is the primary, the rest are extras. */
  value: string;
  /** Title-case each line (legacy values are ALLCAPS). Display only. */
  titleCase?: boolean;
}

/**
 * Renders a newline-joined value as a vertical stack: the first line in normal
 * styling and every subsequent line muted. The Fuel Surcharge Tariff grid uses this
 * for its Bill To / Sage Tag columns so a tariff's primary bill-to sits on top with
 * its additional bill-tos (the fsc_tariff_billto junction) below — the two columns
 * are ordered identically server-side, so line N of Bill To lines up with line N of
 * Sage Tag. Pair with the column's `meta.multiline` so TanTable doesn't truncate it.
 */
export const StackedCell: React.FC<StackedCellProps> = ({ value, titleCase: tc }) => {
  const lines = String(value ?? '').split('\n');
  const fmt = (line: string) => (tc ? titleCase(line) : line);
  return (
    <span className="flex flex-col leading-tight">
      {lines.map((line, i) => (
        <span key={i} className={i === 0 ? '' : 'text-muted'}>
          {fmt(line)}
        </span>
      ))}
    </span>
  );
};

export default StackedCell;
